import OrgchartGroup from './orgchart-group.element.js';

export default OrgchartGroup;

OrgchartGroup.define('wje-orgchart-group', OrgchartGroup);
